import { render, staticRenderFns } from "./Departmental-completion.vue?vue&type=template&id=affe1be8"
import script from "./Departmental-completion.vue?vue&type=script&lang=js"
export * from "./Departmental-completion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports